import type { ReactNode } from 'react'

import { Separator } from '@massilia/ui'

interface EditableSectionProps {
  actionLabel: string
  children: ReactNode
  editForm?: ReactNode
  isEditing: boolean
  onToggleEdit: () => void
}

export function EditableSection({
  actionLabel,
  children,
  editForm,
  isEditing,
  onToggleEdit,
}: EditableSectionProps) {
  return (
    <>
      <div className="flex flex-col-reverse gap-2 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
        <div className="flex-1">{isEditing && editForm ? editForm : children}</div>
        <button
          className="shrink-0 self-end text-sm font-medium whitespace-nowrap text-brand-600 hover:text-brand-700 sm:self-auto"
          onClick={onToggleEdit}
          type="button"
        >
          {isEditing ? 'Annuler' : actionLabel}
        </button>
      </div>
      <Separator />
    </>
  )
}
